import {
  hasAccessRestrictions,
  hasRequiredAccess
} from "utils/auth-access.utils";

import type {
  DestinationAccess,
  QuickLauncherDestination
} from "./destination.types";

export default function isDestinationVisible(
  destination: QuickLauncherDestination,
  access: DestinationAccess
): boolean {
  const { section, featureFlag, hideFlag, roles, permissions, when } =
    destination;
  if (!access.sectionPaths.has(section)) return false;
  if (featureFlag && !access.flags[featureFlag]) return false;
  if (hideFlag && access.flags[hideFlag]) return false;
  if (
    hasAccessRestrictions(roles, permissions) &&
    !hasRequiredAccess(
      access.currentUser,
      access.roles.userRoles,
      access.roles.userPermissions,
      roles,
      permissions
    )
  ) {
    return false;
  }
  return when ? when(access) : true;
}
